<template>
  <div class="products-carousel" :class="{ short: isShort }">
    <h5 v-if="!lightTitle" class="mb-5">{{ title }}</h5>
    <h6 v-else class="mb-5 light-text">{{ title }}</h6>

    <carousel
      :per-page-custom="perPageCustom"
      :navigation-enabled="true"
      navigation-next-label="<i class='icon-angle-right'></i>"
      navigation-prev-label="<i class='icon-angle-left'></i>"
    >
      <slide v-for="item in items" :key="item.id" class="px-3 py-5">
        <product-item :item="item" />
      </slide>
    </carousel>
  </div>
</template>
<script>
import ProductItem from "@/components/marketplace/ProductItem";

export default {
  components: {
    ProductItem
  },
  props: {
    title: {
      type: String,
      default: () => ""
    },
    lightTitle: {
      type: Boolean,
      default: () => false
    },
    items: {
      type: Array,
      default: () => []
    },
    perPageCustom: {
      type: Array,
      default: () => [
        [200, 1],
        [768, 2],
        [992, 4],
        [1300, 4]
      ]
    },
    isShort: {
      type: Boolean,
      default: () => false
    }
  },
  mounted() {
    setTimeout(() => {
      let slides = document.getElementsByClassName("VueCarousel-dot");
      slides.forEach((item, index) => {
        slides[index].removeAttribute("title");
      });
    }, 200);
  }
};
</script>
<style lang="scss" scoped>
.products-carousel {
  ::v-deep .VueCarousel {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  ::v-deep .VueCarousel-pagination {
    bottom: -41px;
    position: absolute;
  }

  ::v-deep .VueCarousel-dot {
    border-radius: 0px;
    height: 2px !important;
    width: 20px !important;
    background-color: #c4c4c4 !important;

    &.VueCarousel-dot--active {
      background-color: #9155ec !important;
      width: 30px !important;
    }
  }

  ::v-deep .VueCarousel-dot:focus {
    outline: none;
  }

  ::v-deep .VueCarousel-navigation-next {
    transform: translateX(100%);
    text-align: left;
    margin-right: 25px;
    margin-top: -21.5%;
    font-size: 20px;

    @media screen and (max-width: 768px) {
      margin-top: -74%;
    }
  }

  &.short {
    ::v-deep .VueCarousel-navigation-next {
      margin-right: 25px;
      margin-top: -30%;

      @media screen and (max-width: 768px) {
        margin-top: -74%;
      }
    }

    ::v-deep .VueCarousel-navigation-prev {
      margin-left: 91.7%;
      margin-top: -30%;

      @media screen and (max-width: 768px) {
        margin-top: -74%;
        margin-left: 80%;
      }
    }
  }

  ::v-deep .VueCarousel-navigation-prev {
    transform: translateX(100%);
    text-align: left;
    margin-left: 93.8%;
    margin-top: -21.5%;
    font-size: 20px;

    @media screen and (max-width: 768px) {
      margin-top: -74%;
      margin-left: 80%;
    }
  }

  ::v-deep .VueCarousel-navigation-prev:focus {
    outline: none;
  }

  ::v-deep .VueCarousel-navigation-next:focus {
    outline: none;
  }

  .light-text {
    font-weight: 500;
  }
  // ::v-deep .VueCarousel-slide {
  //   box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
  // }
}
</style>
